import { useMarketStateFilterInputTools } from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import Utilities from '@util/Utilities';
import ReactDOMServer from 'react-dom/server';
import _orderBy from 'lodash/orderBy';
import {
	useMarketStateTools
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useMarketStateTools';
import GraphUtilities from '@app/site/secured/rateshopper/rates/dashboard/GraphUtilities';

const MarketStateSnapshotAnalyticalGraph = React.memo(() => {

	const tools = useMarketStateTools();
	const { filter } = useMarketStateFilterInputTools();

	Highcharts.SVGRenderer.prototype.symbols.cross = (x: number, y: number, w: number, h: number) => {
		return ['M', x, y, 'L', x + w, y + h, 'M', x + w, y, 'L', x, y + h, 'z'];
	};


	const options = {
		chart: {
			type: 'line',
			height: '700',
		},
		title: {
			text: undefined
		},
		xAxis: {
			categories: tools.marketStateSnapshot?.dailySnapshots.map(ms => Utilities.formatDateString(ms.statDate, 'MMM D', false)),
			alternateGridColor: '#f3f4f6',
			labels: {
				step: 4,
			},
			crosshair: true,
		},
		yAxis: {
			title: {
				text: 'Price',
			},
		},
		tooltip: {
			shared: true,
			useHTML: true,
			// @ts-ignore
			formatter: function() {
				// @ts-ignore
				return ReactDOMServer.renderToString(formatTooltip(this.points, this.points[0]));
			},
			valueDecimals: 2,
		},
		series: GraphUtilities.sortAllSeriesByAveragePrice(
			tools.companyHotel,
			tools.marketStateSnapshot?.dailySnapshots!,
			true,
			false,
			true,
			filter.competitorTagIds
		),

	};

	const formatTooltip = (points: any[], sharedPoint: any) => {
		const orderedPoints = _orderBy(points, 'point.val', 'desc')
		return <table>
			<tr>
				<th className="text-sm font-bold py-0.5 pb-2 border-b border-gray-200" colSpan={4}>
					{sharedPoint.key}
				</th>
			</tr>
			{orderedPoints.map((point, idx) => <tr key={'point_' + idx} className="py-1.5 px-1.5 border-b border-gray-100">
				<td style={{ color: point.series.color }}>
					{Utilities.trim(point.series.name, 30)}
				</td>
				<td style={{ textAlign: 'right' }}>
					<b>{point.point.displayValue}</b>
				</td>
				<td className="whitespace-nowrap px-2 py-2 text-xs" style={{ textAlign: 'left' }}>
					<b>{Utilities.findRoomMappingName(point.point.roomType, tools.companyHotel.roomMappingTypeConfigurations)}</b>
				</td>
				<td className="whitespace-nowrap px-2 py-2 text-xs" style={{ textAlign: 'left' }}>
					<b>{Utilities.trim(point.point.roomName, 35)}</b>
				</td>
			</tr>)}
		</table>;
	};

	return <HighchartsReact
		highcharts={Highcharts}
		options={options}
	/>;
});

export default MarketStateSnapshotAnalyticalGraph;